function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';

var ColumnSearch =
/*#__PURE__*/
function (_Component) {
  _inherits(ColumnSearch, _Component);

  function ColumnSearch() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, ColumnSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = ColumnSearch.__proto__ || Object.getPrototypeOf(ColumnSearch)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "focusInput", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var input = _this.inputContainer && _this.inputContainer.querySelector('.nx-textfield__input');

        input && input.focus();
      }
    }), _temp));
  }

  _createClass(ColumnSearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this; // added setTimeout to resolve the conflict with the popover


      setTimeout(function () {
        _this2.focusInput();
      }, 0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.operator !== prevProps.operator) {
        this.focusInput();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement("div", {
        ref: function ref(el) {
          _this3.inputContainer = el;
        },
        className: "nx-filter-column__search"
      }, this.props.children);
    }
  }]);

  return ColumnSearch;
}(Component);

Object.defineProperty(ColumnSearch, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    children: PropTypes.node,
    operator: PropTypes.string
  }
});
export default ColumnSearch;